/**
 * Schémas Zod — Contacts (filtres listing).
 *
 * Les schémas Create/Update vivent dans `companies.ts` (couplage métier).
 * Ce fichier n'expose que les filtres de listing nested
 * `GET /v1/companies/:id/contacts`.
 */

import { z } from "zod";

export const ContactFilterSchema = z.object({
  q: z.string().max(100).optional(),
  is_primary: z.coerce.boolean().optional(),
});
export type ContactFilter = z.infer<typeof ContactFilterSchema>;
